/**
 * Utilities for navigating to the preloan flow.
 * Centralises origin / token query-string construction so all call-sites
 * stay in sync when the preloan URL shape changes.
 */

/** Build the preloan pathname + search string (does NOT push to history). */
export function getPreloanPath(origin?: string, token?: string): string {
  const params = new URLSearchParams();
  if (origin) params.set('origin', origin);
  if (token) params.set('token', token);
  const search = params.toString();
  return search ? `/preloan?${search}` : '/preloan';
}

/**
 * Build a full preloan path object suitable for `history.push` /
 * `<Redirect to={…} />`.
 */
export function buildPreloanPath(
  origin?: string,
  token?: string,
): { pathname: string; search: string } {
  const params = new URLSearchParams();
  if (origin) params.set('origin', origin);
  if (token) params.set('token', token);
  return {
    pathname: '/preloan',
    search: params.toString() ? `?${params.toString()}` : '',
  };
}

/**
 * Imperatively navigate to the preloan page.
 * Requires a `history` object from `useHistory()` or `withRouter`.
 */
export function navigateToPreloan(
  history: { push: (path: string | { pathname: string; search: string }) => void },
  origin?: string,
  token?: string,
): void {
  history.push(buildPreloanPath(origin, token));
}
